var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H7C6.448 14 6 13.552 6 13V13C6 12.448 6.448 12 7 12H9C9.552 12 10 12.448 10 13V13C10 13.552 9.552 14 9 14Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H5C4.448 10 4 9.552 4 9V9C4 8.448 4.448 8 5 8H11C11.552 8 12 8.448 12 9V9C12 9.552 11.552 10 11 10Z",
    fill: "#64748B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H3C2.448 6 2 5.552 2 5V5C2 4.448 2.448 4 3 4H13C13.552 4 14 4.448 14 5V5C14 5.552 13.552 6 13 6Z",
    fill: "#64748B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H1C0.448 2 0 1.552 0 1V1C0 0.448 0.448 0 1 0H15C15.552 0 16 0.448 16 1V1C16 1.552 15.552 2 15 2Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.c5f9da29a50c399a62abc0e0ebabf70c.svg";
export { ForwardRef as ReactComponent };